import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useLeagueId = () => {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const raw = params.get('idleague');
    const parsed = Number(raw);

    if (Number.isInteger(parsed) && parsed > 0) {
      return parsed;
    }

    return 1;
  }, [location.search]);
};
